export const formatPermissionsManagementSelectedLabel = (count: number): string =>
  `${count} selected`;

export const togglePermissionsManagementUserSelection = (
  selectedUserIds: ReadonlyArray<string>,
  userId: string,
): ReadonlyArray<string> => {
  if (selectedUserIds.includes(userId)) {
    return selectedUserIds.filter(id => id !== userId);
  }

  return [...selectedUserIds, userId];
};

export const togglePermissionsManagementPageSelection = (
  selectedUserIds: ReadonlyArray<string>,
  pageUserIds: ReadonlyArray<string>,
): ReadonlyArray<string> => {
  const allPageUsersSelected =
    pageUserIds.length > 0 &&
    pageUserIds.every(userId => selectedUserIds.includes(userId));

  if (allPageUsersSelected) {
    const pageUserIdSet = new Set(pageUserIds);

    return selectedUserIds.filter(userId => !pageUserIdSet.has(userId));
  }

  return Array.from(new Set([...selectedUserIds, ...pageUserIds]));
};

export const getPermissionsManagementPageSelectionState = (
  selectedUserIds: ReadonlyArray<string>,
  pageUserIds: ReadonlyArray<string>,
): Readonly<{allSelected: boolean; someSelected: boolean}> => {
  if (pageUserIds.length === 0) {
    return {allSelected: false, someSelected: false};
  }

  const selectedOnPageCount = pageUserIds.filter(userId =>
    selectedUserIds.includes(userId),
  ).length;

  return {
    allSelected: selectedOnPageCount === pageUserIds.length,
    someSelected:
      selectedOnPageCount > 0 && selectedOnPageCount < pageUserIds.length,
  };
};
